
    <mat-dialog-content>
        <p><strong>{{data}}</strong></p>
    </mat-dialog-content>
    <mat-dialog-actions>
        <button class="yesButton" fxFlexAlign="flex-start" (click)="Confirm()">Ok</button>
    </mat-dialog-actions>

